/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react';
import moment from 'moment-timezone';
import Submit from './components/Submit';
import ResourceSelect from './components/ResourceSelect';
import LocationSelect from './components/LocationSelect';
import Alert from '../components/Alert';
import Spinner from '../components/Spinner';
import ProductOptions from './components/ProductOptions.js';
import RentalDatePicker from '../components/RentalDatePicker';
import TimeZone from '../components/Common/TimeZone';
import Price from './components/Price';
import VariantSelect from './components/VariantSelect';
import ExceededMessage from "../components/exceeded_free_trial_message.js";
import { dateTimeFormat } from '../utilities/timeUtility';

import { capitalize, parseAvailableDates } from '../utilities/helperUtility';
import Translation from '../utilities/localizationUtility';
import { stringToBoolean } from '../utilities/conversionUtility';
import _ from 'lodash';

import { SHORT_DATE_FORMAT } from '../constants';

const styles = {
  formGroupContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '6px 0',
    justifyContent: 'space-between',
  },
  labelText: {
    fontSize: '16px',
    padding: '4px 0',
  },
  inputStyle: {
    flex: '1',
    padding: '5px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  formGroup: {
    flexGrow: '1',
    display: 'flex',
    padding: '0 4px 0 0',
    flexDirection: 'column',
  },
  inputGroup: {
    display: 'flex',
  },
};

/**
 * check if a date array contains `date` inside.
 * @param {Array} blackoutsArr - blackout array
 * @param {Date} date - date to compare
 * @returns {Boolean} true if one of blackoutsArr's elements contains date inside, false if otherwise.
 * */
function isDateInDateRange(dateArr, date) {
  return dateArr && dateArr.some(dateElement => moment(new Date(date).setHours(0, 0, 0, 0, 0))
    .isBetween(new Date(dateElement.start).setHours(0, 0, 0, 0),
      new Date(dateElement.finish).setHours(0, 0, 0, 0), null, '[]'));
}

/**
 * Get days between two dates.
 * @param {Date} startDate - Start date
 * @param {Date} endDate - End Date.
 */
function enumerateDaysBetweenDates(startDate, endDate) {
  const dates = [],
        now = moment(startDate).clone();
  let newNow = now;
  while (newNow.isSameOrBefore(endDate)) {
    dates.push(now.toDate());
    newNow = now.add(1, 'days');
  }
  return dates;
}

export default class RentalPage extends PureComponent {
  state = {
    start: null,
    duration: 0,
    finish: null,
    enteredTo: null,
    durationValue: 0,
    hoverStart: null,
    daySelected: null,
    // Range select
    hoverEnteredTo: null,
    remainingCapacity: 0,
    availableDates: [],
    currentMonth: moment(Date.now()).startOf('month'),
  };

  constructor(props) {
    super(props);
    this.onSubmitBound = this.onSubmit.bind(this);
    this.onDayClickBound = this.onDayClick.bind(this);
    this.onMonthClickBound = this.onMonthClick.bind(this);
    this.handleDayMouseEnterBound = this.handleDayMouseEnter.bind(this);
    this.handleDayMouseLeaveBound = this.handleDayMouseLeave.bind(this);
  }

  dayDisabled = this.dayDisabled.bind(this);

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (((nextProps.order.selectedResource || {}).id !== (this.props.order.selectedResource || {}).id) ||
      ((nextProps.order.selectedLocation || {}).id !== (this.props.order.selectedLocation || {}).id) ||
      (nextProps.order.variantSelected !== this.props.order.variantSelected)) {
      this.featchDate(true, nextProps);
    }

    const { timeslots, minDate, maxDate, timeZone } = nextProps,
    availableDatesTemp = parseAvailableDates(timeslots, minDate, maxDate, timeZone);
    if (availableDatesTemp.length >= 0) this.setState({ availableDates: availableDatesTemp })
  }

  componentDidMount() {
    const {
      variants,
      order: { variantSelected },
      orderActions: { setSelectedVariant }
    } = this.props;
    if (!variantSelected && !!variants && !!variants[0]) setSelectedVariant(variants[0].external_id);
  }

  getTypeValue(type) {
    switch (type) {
      case 0:
        return 'product';
      case 1:
        return 'variant';
      case 2:
        return 'resource';
      default:
        return 'product';
    }
  }

  getDaysArray(start, end) {
    for(var arr=[],dt=new Date(start); dt<=end; dt.setDate(dt.getDate()+1)){
      arr.push(new Date(dt));
    }
    return arr;
  };

  // select day event.
  onDayClick(day) {
    this.isSingleOneDayVariant() ? this.onSetDate(day) : this.onSetDateRange(day)
  }

  onSetDate(day) {
    const { leadTime, lagTime , rangeCountBasis} = this.props,
          { start, finish } = this.state,
          selectedDay = moment(day).startOf('day'),
          leadLagSum = leadTime + lagTime,
          isStart = !start || start && finish;

    if ( isStart || start > day ) {
      const offset = leadLagSum + (rangeCountBasis == 0 ? 1 : 0);

      if (this.matchUnavailableBlocks(day, moment(day).add(offset, 'days'))) return;

      this.setState({
        start: selectedDay.toDate(),
        daySelected: selectedDay.toDate(),
        finish: null,
        enteredTo: null,
      });
    } else {
      if (this.matchUnavailableBlocks(start, day)) return;

      let finishDate = selectedDay.toDate();

      if (rangeCountBasis == 0 && moment(finishDate).isSame(start, 'date')) {
        finishDate = moment(finishDate).add(1, 'days').toDate()
      }

      const selectDay = {
        start: start,
        daySelected: this.state.daySelected,
        finish: finishDate,
        enteredTo: finishDate,
      }

      this.setDateRange(day, selectDay)
    }
  }

  matchUnavailableBlocks(start, finish) {
    const { availableBlocks, timeslots } = this.props;

    if (moment(start).isSame(finish, 'month')) {
      return this.getDaysArray(start, finish).some((date) => {
        if (!timeslots.find(slot => moment(slot.date).isSame(date, 'date'))) return false
        return _.isEmpty(availableBlocks.find(block => moment(block.date).isSame(date, 'date')))
      });
    } else {
      return this.getDaysArray(moment(finish).startOf('month').toDate(), finish).some((date) => {
        if (!timeslots.find(slot => moment(slot.date).isSame(date, 'date'))) return false
        return _.isEmpty(availableBlocks.find(block => moment(block.date).isSame(date, 'date')))
      });
    }
  }

  onSetDateRange(day) {
    const { rangeCountBasis, nonAvailableBlocks } = this.props,
          { duration } = this.state,
          selectedDuration = rangeCountBasis == 0 ? duration + 1 : duration,
          selectedDay = moment(day).startOf('day');

    const selectDay = {
      start: selectedDay.toDate(),
      daySelected: selectedDay.toDate(),
      finish: selectedDay.clone().add(selectedDuration, 'days').add(-1, 'seconds').toDate(),
      enteredTo: selectedDay.clone().add(selectedDuration, 'days').add(-1, 'seconds').toDate(),
    }

    this.setDateRange(day, selectDay)
  }

  matchMinMaxDurationInterval(start, finish) {
    const { minDuration, maxDuration, rangeCountBasis } = this.props,
          finishDate = moment(finish);

    if (!this.isSingleOneDayVariant()) return true

    const offset = rangeCountBasis == 1 ? -1 : 0;

    if (minDuration != 0 && finishDate.isBefore(moment(start).add(minDuration + offset, 'days'))) return
    if (maxDuration != 0 && finishDate.isAfter(moment(start).add(maxDuration + offset, 'days'))) return

    return true
  }

  setDateRange(day, selectDay) {
    const {
      blackouts,
      availableBlocks,
      nonAvailableBlocks,
      orderActions: { setDateRange },
    } = this.props;

    const { duration } = this.state,
          { start, finish } = selectDay;

    const availableBlock = availableBlocks.find(block => moment(block.date).isSame(start, 'date')),
      selectedRange = availableBlock ? {
        start: moment(start).format(SHORT_DATE_FORMAT),
        finish: moment(finish).format(SHORT_DATE_FORMAT),
      } : {};

    // If does not match min max duration interval then return.
    if (!this.matchMinMaxDurationInterval(start, finish)) return

    // If client clicks on a non available block then return.
    if (nonAvailableBlocks.some(nBlock => moment(nBlock).isSame(day, 'date'))) return;

    // if selected day is a previous day of today then return.
    if (moment(new Date(Date.now())).isAfter(new Date(day).setHours(0, 0, 0, 0), 'day')) return;

    // if selected day is a blackout block then return.
    if (blackouts.length > 0 && blackouts.find(
        blackout => moment(blackout.date).isSame(start, 'date'),
      )) return;

    // if selected day is a booked block then return.
    if (this.isBlockUnavailable(day)) return;

    setDateRange({
      start: selectedRange.start,
      finish: selectedRange.finish,
      duration,
    });

    this.setState(selectDay);
  }

  onSubmit(e) {
    const messages = [],
          ele = e.target,
          { orderActions, cartActions, setting, quantityRange } = this.props,
          { duration } = this.state,
          { valid, message } = this.getValidMessage();

    if (valid) {
      orderActions
        .submitRentalOrder()
        .then((response) => {
          const { reservation } = response.data;
          if (reservation.items.some(x => x.status !== 'ok')) {
            let m = 'SCHEDULE CONFLICT PLEASE RELOAD PAGE';

            if (window.screen.width < 380) m = 'PLEASE RELOAD PAGE';
            this.alert.show('red', [m]);
            ele.innerText = m;
          } else {
            let type = ['Start'],
                quantity = null,
                isSingleOneDayVariant = this.isSingleOneDayVariant();

            if (setting.include_returned_date != '0' || isSingleOneDayVariant) type.push('Finish');
            if (quantityRange && isSingleOneDayVariant) {
              quantity = this.getQuantity();
              type.push('Units')
            }

            type.push('Resource', '_resource_ids', 'Location')

            cartActions.addItems(reservation, type, {}, quantity);
          }
        })
        .catch((responsed) => {
          ele.disabled = false;
          const { response } = responsed;
          if (response && response.data) {
            const { data } = response;
            Object.keys(data).forEach((key) => {
              const name = key
                .split('_')
                .map(x => capitalize(x))
                .join('');
              messages.push(`${name} ${data[key]}`);
            });

            this.alert.show('red', ['SERVER ERROR']);
          } else {
            this.alert.show('red', ['SOMETHING WRONG']);
            throw responsed;
          }
        });
    } else {
      if (this.alert) this.alert.show('red', [message]);
    }
  }

  getValidMessage() {
    const {
      order,
      capacity,
      locations,
      setting
    } = this.props;

    const { finish } = this.state,
          showLocation = stringToBoolean(setting.show_location_chooser),
          showResource = stringToBoolean(setting.show_resource_chooser),
          enableResourceDropdown = showResource && capacity.type == 2,
          enableLocationDropdown = showLocation && locations.length > 0;

    if (!finish) return {valid: false, message: 'PLEASE SELECT FINISH DATE'}

    let valid = true,
      message = 'PLEASE SELECT PRODUCT ';

    if (enableResourceDropdown && !order.selectedResource) {
      valid = false;
      message += "RESOURCE"
    }

    if (enableLocationDropdown && !order.selectedLocation) {
      valid = false;
      if (message.indexOf('RESOURCE') > -1 ) { message += " AND " }
      message += "LOCATION"
    }

    return {valid: valid, message: message}
  }

  getQuantity() {
    const { start, finish } = this.state;

    if (!start || !finish) return 1

    const { rangeCountBasis } = this.props,
          daysCount = this.getDaysArray(start, finish).length;

    return daysCount - (rangeCountBasis == 0 ? 1 : 0)
  }

  getOffset(initialOffset) {
    const { rangeCountBasis, lagTime, leadTime } = this.props,
          { start, finish } = this.state,
          leadLagSum = leadTime + lagTime;

    let offset = rangeCountBasis == 0 ? 1 : 0;

    if (initialOffset) offset = initialOffset;

    if (rangeCountBasis == 0 && this.isSingleOneDayVariant() && start && !finish) {
      offset = 0;
    }

    return leadLagSum + offset
  }

  isSingleOneDayVariant() {
    return this.props.variants.length == 1 && this.state.duration == 1
  }

  isBlockUnavailable(day) {
    const { timeslots } = this.props;

    if (!timeslots) return false

    const { leadTime, rangeCountBasis } = this.props,
      { start, finish, duration } = this.state,
      d = rangeCountBasis == 0 ? duration : duration - 1;

    const timeslot = timeslots.find(
      block =>
        block.timeslots[0].status === 2 && isDateInDateRange([{
          start: moment(block.date).subtract(this.getOffset(d), 'days').toDate(),
          finish: block.date,
        }], day) || block.timeslots[0].status === 3 && isDateInDateRange([{
          start: moment(block.date).subtract(this.getOffset(), 'days').toDate(),
          finish: moment(block.date).add(leadTime, 'days').toDate(),
        }], day),
    )

    return !_.isEmpty(timeslot)
  }

  onMonthClick = (day) => {
    const {
        order: preOrder,
        setting: { interval },
        exceededTrialPlan,
        timeZone,
        frameActions: { fetchBlocks, setCurrentMonth },
      } = this.props,
      startDate = this.state.start,
      finishDate = this.state.finish,
      date = moment(day),
      start = moment([date.year(), date.month()]),
      finish = moment(start).add(45, 'days');

    setCurrentMonth(date);
    this.setState({ currentMonth: moment(day).startOf('month') });
    if (this.spinner) this.spinner.show();

    if (startDate && !finishDate && startDate < start.toDate()) {
      let match = this.matchUnavailableBlocks(startDate, moment(startDate).endOf('month').toDate())
      if (match) {
        this.setState({
          start: null,
          daySelected: null,
          finish: null,
          enteredTo: null,
        });
      }
    }

    if (!exceededTrialPlan) {
      fetchBlocks(
        preOrder.variantSelected,
        start,
        finish,
        preOrder.selectedLocation ? preOrder.selectedLocation.id : null,
        preOrder.selectedResource ? preOrder.selectedResource.id : null,
        interval,
        timeZone
      );
    }
  };

  handleResetClick() {
    this.setState({
      start: null,
      finish: null,
      enteredTo: null,
    });
  }

  handleDayMouseEnter(day) {
    const { rangeCountBasis, availableBlocks } = this.props,
          { start, finish, duration } = this.state,
          d = rangeCountBasis == 0 ? duration : duration - 1,
          isStart = !start || start && finish;

    // if hovered day is a booked block then return.
    if (this.isBlockUnavailable(day)) return;

    const dayBlock = availableBlocks
      .map(block => ({
        start: moment(block.date).toDate(),
        finish: moment(block.date).add(d, 'days').toDate(),
      }))
      .find(block => moment(block.start).isSame(isStart ? day : start, 'date'));

    if (dayBlock) {
      this.setState({
        hoverStart: isStart ? dayBlock.start : start,
        hoverEnteredTo: isStart ? dayBlock.finish : day,
      });
    }
  }

  handleDayMouseLeave() {
    this.setState({
      hoverStart: null,
      hoverEnteredTo: null,
    });
  }

  featchDate = (init = false, props) => {
    const newState = {
      start: null,
      finish: null,
      enteredTo: null,
      durationValue: 0,
      duration: 0,
      remainingCapacity: 0,
      capacity: 0
    };

    const {
      capacity,
      variants,
      durations,
      options,
      setting: { interval },
      frameActions: { fetchBlocks },
      orderActions: { setSelectedVariant },
      order: { selectedResource, selectedLocation, variantSelected },
      timeZone
    } = props || this.props;
    const { durationValue, currentMonth } = this.state;
    const newSelectedVariant = variants.find(v => v.external_id == variantSelected) || {};

    if (!_.isEmpty(newSelectedVariant)) {
      // Set new capacity state
      newState.remainingCapacity = (this.getTypeValue(capacity.type) === 'variant') ? (newSelectedVariant.capacity || 0) : capacity.capacity;
      if (this.getTypeValue(capacity.type) === 'resource' && selectedResource) {
        newState.capacity = selectedResource.inventory;
      }

      // Set new duration state
      if (this.getTypeValue(durations.type) === 'variant') {
        const optionIdx = _.findIndex(options, o => o.name == durations.option);
        newState.durationValue = durations.option_durations.find(d => d.value == newSelectedVariant.options[optionIdx]).duration;
      } else {
        newState.durationValue = durations.duration;
      }
      if (newState.durationValue !== undefined) newState.duration = newState.durationValue / 86400;

      // Fetch blocks
      fetchBlocks(
        variantSelected,
        currentMonth.format(SHORT_DATE_FORMAT),
        currentMonth.clone().add(45, 'days').format(SHORT_DATE_FORMAT),
        selectedLocation ? selectedLocation.id : null,
        selectedResource ? selectedResource.id : null,
        interval,
        timeZone
      );
    } else if (this.alert) {
      if (this.getTypeValue(capacity.type) === 'variant') {
        this.alert.show('red', ['Chosen variant is not available at the moment, please choose another one.']);
      }
    }

    if (this.spinner) this.spinner.show();
    this.setState(newState);
  }

  dayDisabled(value) {
    const currentDate = new Date(Date.now()),
          day = moment(value).format(SHORT_DATE_FORMAT),
          { availableDates, duration } = this.state;

    if (!availableDates.includes(day) || moment(value).isBefore(currentDate.setHours(0, 0, 0, 0)) || duration == 0) {
      return new Date(day);
    }
    return null;
  }

  render() {
    const {
      style,
      options,
      setting,
      timeZone,
      capacity,
      leadTime,
      timeslots,
      blackouts,
      durations,
      quantityRange,
      rangeCountBasis,
      isFetchingBlocks,
      nonAvailableBlocks,
      order: { variantSelected },
      exceededTrialPlan,
      resources,
      locations,
      variants,
      region
    } = this.props;

    const {
      start,
      finish,
      duration,
      enteredTo,
      hoverStart,
      daySelected,
      durationValue,
      hoverEnteredTo,
      remainingCapacity,
    } = this.state;

    const t = new Translation(this.props),
          d = rangeCountBasis == 0 ? duration : duration - 1,
          daysBetween = enumerateDaysBetweenDates(hoverStart, hoverEnteredTo),
          showResourceChooser = stringToBoolean(setting.show_resource_chooser),
          showLocationChooser = stringToBoolean(setting.show_location_chooser),
          enableResourceDropdown = showResourceChooser && this.getTypeValue(capacity.type) === 'resource' && resources.length > 1,
          enableLocationDropdown = showLocationChooser && locations.length > 0,
          variantsLength = variants.length,
          enableVariantDropdown = variantsLength > 1 || variantsLength == 1 && variants[0].title != 'Default Title';

    const blackoutsArr = blackouts.map(blackout => ({
            start: moment(blackout.date).toDate(),
            finish: moment(blackout.date).toDate(),
          }));

    let multiplier = 1;
    if (quantityRange && this.isSingleOneDayVariant()) multiplier = this.getQuantity();

    const selectedVariant = variants.find(v => v.external_id == variantSelected),
          price = selectedVariant && selectedVariant.price ? (selectedVariant.price * multiplier).toFixed(2) : Number(0).toFixed(2);

    return (
      <div className="center" style={{ ...style.body, maxWidth: '450px', minHeight: 635 }}>
        <div className="sub-panel">
          <h3 className="text-left" style={{ ...style.title, marginTop: '0' }}>
            {t.key('title')}
          </h3>

          {exceededTrialPlan &&
            <div className="text-left">
              <Alert unclosed={true} messages={[<ExceededMessage/>]} type="exceeded-trial-plan" />
            </div>
          }

          <div style={{ marginBottom: '10px' }}>
            {enableVariantDropdown &&
            <div className='text-left mt10'>
              <span className='titles' style={{...style.body}}> {t.key('variants')} </span>
              <VariantSelect priceSymbol={t.key('priceSymbol')} className="mt10" />
            </div>
            }

            {enableResourceDropdown &&
              <div className='text-left mt10'>
                <span className='titles' style={{...style.body}}>{t.key('resourcePrompt')}</span>
                <ResourceSelect className="mt15" />
              </div>
            }

            {enableLocationDropdown &&
              <div className='text-left mt10'>
                <span className='titles' style={{...style.body}}>{t.key('locationPrompt')}</span>
                <LocationSelect className="mt15" />
              </div>
            }
          </div>

          <div className="relative">
            <Spinner ref={ref => (this.spinner = ref)} />
            <RentalDatePicker
              to={finish}
              from={start}
              region={region}
              setting={setting}
              translation={t}
              enteredTo={enteredTo}
              hoverStart={hoverStart}
              hoverEnteredTo={hoverEnteredTo}
              onDayClick={this.onDayClickBound}
              onMonthChange={this.onMonthClickBound}
              handleDayMouseEnter={this.handleDayMouseEnterBound}
              handleDayMouseLeave={this.handleDayMouseLeaveBound}
              innerRef={ref => (this.dayPicker = this.dayPicker || ref)}
              isDisableCalendar={
                // disable calendar while fetching blocks
                isFetchingBlocks
                // disable calendar when duration value equals to 0
                || durationValue === 0
                // disable calendar when remaining capacity equals to 0
                // (when capacity types are variant_option and resource)
                || remainingCapacity === 0
              }
              styled={{ ...style.datepicker, ...style.body, ...{ hoverColor: style.button.hover, textAlign: 'center', legendBackgroundColor: setting.legend_background_color } }}
              modifiers={{
                start,
                hoverStart,
                hoverEnteredTo,
                end: enteredTo,
                selected: daySelected,
                disabled: this.dayDisabled,
                hoverHighlight: daysBetween,
                nonAvailable: nonAvailableBlocks,
                blackoutOverlap: blackoutsArr ? blackoutsArr.map(blackoutEl => ({
                  to: blackoutEl.finish,
                  from: moment(blackoutEl.start).subtract(this.getOffset(d), 'days').toDate(),
                })) : [],
                bookedDates: timeslots ? timeslots.map(timeslot => {
                  return {
                    from: timeslot && timeslot.timeslots[0].status === 3
                    && moment(timeslot.date).subtract(this.getOffset(), 'days').toDate(),
                    to: timeslot && timeslot.timeslots[0].status === 3
                    && moment(timeslot.date).add(leadTime, 'days').toDate(),
                  }
                }) : [],
              }}
            />
          </div>

          <div style={styles.formGroupContainer} className="form-group-container">
            {!stringToBoolean(setting.hide_start_date) && (
              <div className="form-group" style={styles.formGroup}>
                <label style={styles.labelText} className="col-sm-3 control-label">{t.key('pickUpDate')}</label>
                <div style={styles.inputGroup} className="col-sm-9">
                  <input
                    readOnly
                    type="text"
                    className="form-control"
                    style={styles.inputStyle}
                    value={start ? moment(start).format(dateTimeFormat(true)) : ''}
                  />
                </div>
              </div>
            )}
            {stringToBoolean(setting.include_returned_date) && (
              <div style={styles.formGroup} className="form-group">
                <label style={styles.labelText} className="col-sm-3 control-label">{t.key('returnDate')}</label>
                <div style={styles.inputGroup} className="col-sm-9">
                  <input
                    readOnly
                    type="text"
                    className="form-control"
                    style={styles.inputStyle}
                    value={finish ? moment(finish).format(dateTimeFormat(true)) : ''}
                  />
                </div>
              </div>
            )}
          </div>
          <div>
            <Alert ref={ref => (this.alert = ref)} />

            <TimeZone timeZone={timeZone}/>

            <Price price={price} style={{...style.body}} title={`${t.key('price')}`}/>

            <Submit onSubmit={this.onSubmitBound} className="submit" canBook={!!variantSelected && (start || finish)} />
          </div>
        </div>
      </div>
    );
  }
}

RentalPage.propTypes = {};
